import React from 'react';
import Loading from './Loading';

const PageLoading = () => (
		<Loading type="config" />
);

export default PageLoading;
